import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { heldToolState } from '~/state/atoms/toolsAtoms';
import { useContouringToolEntries } from './useContouringToolEntries';

/**
 * Lets go of the held contouring tool once its entry is disabled, for
 * example when the selection changes to an approved or a point structure.
 * A held tool stays held only while it could still be picked, so it never
 * arms where its button reads unavailable. Renders nothing.
 */
export default function UnavailableHeldToolRelease() {
    const setHeldTool = useSetRecoilState(heldToolState);
    const heldEntryDisabled = Object.values(useContouringToolEntries()).some(
        (entry) => entry.held && entry.disabled
    );
    useEffect(() => {
        if (heldEntryDisabled) {
            setHeldTool(null);
        }
    }, [heldEntryDisabled, setHeldTool]);
    return null;
}
